import { useTranslation } from "react-i18next";
import { useFuneralHome } from "../context/FuneralHomeContext";
import AccountingEntityDropdown from "./dropdown/AccountingEntityDropdown";
import { getAccountingEntityId } from "../models/AccountingEntity";

function FuneralHomeHandler() {
  const {
    accountingEntities,
    isLoading,
    error,
    selectedAccountingEntity,
    setSelectedAccountingEntity,
  } = useFuneralHome();
  const { t } = useTranslation();

  const handleEntityChange = (selectedId: string) => {
    const entity = accountingEntities.find(
      (e) => getAccountingEntityId(e) === selectedId
    );
    if (entity) {
      setSelectedAccountingEntity(entity);
    }
  };

  return (
    <>
      {isLoading && <p className="text-info">{t("loading.funeralhome")}</p>}
      {error && (
        <p className="text-danger">
          {t("error.funeralhome", { message: error })}
        </p>
      )}

      {/* Select Accounting Entity Dropdown */}
      {accountingEntities.length > 0 && (
        <div className="form-group mt-3">
          <label htmlFor="accountingEntitySelect">{t("funeralhome.select")}</label>
          <AccountingEntityDropdown
            selectedEntityId={
              selectedAccountingEntity
                ? getAccountingEntityId(selectedAccountingEntity)
                : ""
            }
            handleChange={(value) => handleEntityChange(value)}
            entities={accountingEntities}
          />
        </div>
      )}

      {!selectedAccountingEntity && accountingEntities.length > 0 && (
        <p className="text-info mt-3">{t("funeralhome.selectrequired")}</p>
      )}
    </>
  );
}
export default FuneralHomeHandler;
